<div class="main-screen-container">
    <div class="top-row">
        <button mat-flat-button color="accent" (click)="router.navigate(['/rekbots-list'])"><img style="width:25px;"
                    src="/assets/img/back.png" alt=""> Lista maszyn</button>
        <h3 class="flex-fill">Rekbot {{ rekbot.serial_no }}</h3>
        <div class="d-flex flex-row flex-wrap gap-3 pt-3 pb-3 w-100" >
            <!-- <button mat-flat-button color="accent" [routerLink]="['./']" routerLinkActive="active-tab" [routerLinkActiveOptions]="{ exact:true }">Informacje</button>
            <button mat-flat-button color="accent" routerLink='edit' routerLinkActive="active-tab">Edytuj</button>
            <button mat-flat-button color="accent" routerLink='location' routerLinkActive="active-tab">Mapa</button>
            <button mat-flat-button color="accent" class="btn btn-primary btn-action" routerLinkActive="active-tab"
                (click)="decodeLocationData()">Pobierz lokalizację</button>
            <button mat-flat-button color="accent" routerLink='settings' routerLinkActive="active-tab">Ustawienia</button>
            <button mat-flat-button color="accent" routerLink='email-config-list' routerLinkActive="active-tab">Konfiguracja Email</button>
            <button mat-flat-button color="accent" routerLink='notes' routerLinkActive="active-tab">Notatki i wpisy</button> -->

            <ng-container *ngFor="let btn of buttons">
                <button
                    *ngIf="btn.permission"
                    mat-flat-button
                    color="accent"
                    [routerLink]="btn.route ? [btn.route] : null"
                    routerLinkActive="active-tab"
                    [routerLinkActiveOptions]="btn.exact ? { exact: true } : { exact: false } "
                    (click)="btn.action ? btn.action() : null"
                >
                    {{ btn.label }}
                </button>
            </ng-container>

            <!-- <button mat-flat-button class="btn btn-primary btn-action" color="accent" (click)="fetchSmtpFromRekbot()">Pokaż ustawienia SMTP Rekbot-a</button> -->
            <!-- <button mat-flat-button color="accent" (click)="fetchLogFromRekbot()">Odśwież Logi Rekbot-a</button> -->
            
        </div>
    </div>
    <mat-divider/>
    <mat-card class="list-container">
        <mat-card-content>
            <router-outlet/>
        </mat-card-content>
    </mat-card>
</div>

